/*Splitting();*/

window.logoCubeFunc = function logoCubeFunc() {
  const logoCubeArr = document.querySelectorAll('.logo .cube');
  logoCubeArr.forEach((logoCube) => {
    if (logoCube && !logoCube.classList.contains('is-init-logo-cube')) {
      const parentLogoEl = logoCube.closest('.logo');
      const parentLogoLinkEl = logoCube.closest('.logo-link');
      const parentPopupLoaderEl = logoCube.closest('.popup-form__logo-loader');

      logoCube.classList.add('is-init-logo-cube');

      const steps = [
        { x: 0, y: -90, z: 0, class: 'rotate-b' },
        { x: 90, y: -90, z: 0, class: 'rotate-o' },
        { x: 90, y: -180, z: -90, class: 'rotate-l' },
        { x: 90, y: -180, z: -180, class: 'rotate-d' },
      ];

      let currentStep = 0;
      let interval;
      let timeout;

      let timerAnim = 500;
      let intervalAnim = 1000;

      function logoStartAnimFunc(timerAnim, intervalAnim) {
        clearInterval(interval);
        clearTimeout(timeout);
        currentStep = 0;

        parentLogoEl.classList.remove(
          'rotate-b',
          'rotate-o',
          'rotate-l',
          'rotate-d'
        );
        logoCube.style.transform = `rotateX(0deg) rotateY(0deg) rotateZ(0deg)`;

        timeout = setTimeout(() => {
          const step = steps[currentStep];
          logoCube.style.transform = `rotateX(${step.x}deg) rotateY(${step.y}deg) rotateZ(${step.z}deg)`;
          parentLogoEl.classList.add(step.class);
          currentStep++;

          interval = setInterval(() => {
            if (currentStep >= steps.length) {
              clearInterval(interval);
              return;
            }

            const step = steps[currentStep];

            logoCube.style.transform = `rotateX(${step.x}deg) rotateY(${step.y}deg) rotateZ(${step.z}deg)`;

            parentLogoEl.classList.remove(
              'rotate-b',
              'rotate-o',
              'rotate-l',
              'rotate-d'
            );
            parentLogoEl.classList.add(step.class);

            currentStep++;
          }, intervalAnim);
        }, timerAnim);
      }

      function logoEndAnimFunc() {
        clearInterval(interval);
        clearTimeout(timeout);
        currentStep = 0;
        logoCube.style.transform = `rotateX(0deg) rotateY(0deg) rotateZ(0deg)`;
        parentLogoEl.classList.remove(
          'rotate-b',
          'rotate-o',
          'rotate-l',
          'rotate-d'
        );
      }

      if (parentLogoLinkEl) {
        parentLogoLinkEl.addEventListener('mouseenter', () => {
          logoStartAnimFunc(timerAnim, intervalAnim);
        });

        parentLogoLinkEl.addEventListener('mouseleave', () => {
          logoEndAnimFunc();
        });
      }

      if (parentPopupLoaderEl) {
        timerAnim = 1000;
        intervalAnim = 700;
        logoStartAnimFunc(timerAnim, intervalAnim);
      }
    }
  });
};

logoCubeFunc();

AOS.init({
  offset: 50,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});
import Parallax from 'parallax-js';

// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

window.addEventListener('load', () => {
  AOS.refresh();
});

window.initParallaxJSAnimation = function initParallaxJSAnimation() {
  if (
    document.querySelector('[data-parallax-el]') &&
    window.innerWidth >= 1025
  ) {
    const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
    parallaxContainer.forEach((elem) => {
      let parallaxInstance = new Parallax(elem);
      parallaxInstance.enable();
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  initParallaxJSAnimation();
}

if (document.querySelector('[data-duplicate]')) {
  const originalArr = document.querySelectorAll('[data-original]');
  const duplicateArr = document.querySelectorAll('[data-duplicate]');

  originalArr.forEach((originalElement) => {
    const originalValue = originalElement.dataset.original;
    duplicateArr.forEach((duplicateElement) => {
      const duplicateValue = duplicateElement.dataset.duplicate;
      if (originalValue === duplicateValue) {
        duplicateElement.textContent = originalElement.textContent;
      }
    });
  });
}

if (document.querySelector('[data-splitting]')) {
  const splittingArr = document.querySelectorAll('[data-splitting]');
  splittingArr.forEach((item, i) => {
    if (item.hasAttribute('data-splitting-char') === true) {
      const splitting = Splitting({
        target: item,
      });
    } else {
      const splitting = Splitting({
        target: item,
        by: 'words',
      });
    }
  });
}

if (document.querySelector('[data-splitting-image]')) {
  const splittingImageArr = document.querySelectorAll('[data-splitting-image]');
  splittingImageArr.forEach((item, i) => {
    item.classList.add(`splitting-img-${i + 1}`);
    const splitting = Splitting({
      target: item,
      by: 'cells',
      image: true,
    });

    function addAnimatedClassFunc() {
      setTimeout(function () {
        item.classList.add('animated');
      }, 100);
    }

    createVisibilityObserver(
      `splitting-img-${i + 1}`,
      addAnimatedClassFunc,
      0.05
    );
  });
}

window.initTilt = function initTilt() {
  if (
    typeof VanillaTilt !== 'undefined' &&
    document.querySelector('[data-tilt-init]') &&
    window.innerWidth > 1024
  ) {
    const tiltInitItemsArr = document.querySelectorAll('[data-tilt-init]');
    tiltInitItemsArr.forEach((item) => {
      if (item.vanillaTilt) {
        return;
      }

      const tiltMax = Number(item.dataset.tiltMax);
      const options = {
        speed: 500,
      };

      if (Number.isFinite(tiltMax)) {
        options.max = tiltMax;
      }

      VanillaTilt.init(item, options);
    });
  }
};
if (!document.querySelector('.bold-loader-new')) {
  initTilt();
}

if (document.querySelector('.anime-motion-animation')) {
  const animeMotionAnimElArr = document.querySelectorAll(
    '.anime-motion-animation'
  );
  animeMotionAnimElArr.forEach((animeMotionAnimEl) => {
    const defaultSpeed = 3000;
    const originalSpeed =
      Number(parseFloat(animeMotionAnimEl.getAttribute('data-anime-speed'))) ||
      defaultSpeed;

    const petaAnimation = anime({
      targets: animeMotionAnimEl.querySelector('svg path'),
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: originalSpeed,
      delay: function (el, i) {
        return i * 1;
      },
      direction: 'normal',
      loop: false,
    });
    petaAnimation.pause();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              petaAnimation.play();
              animeMotionAnimEl.classList.add('animated');
            }, 600);
            observer.unobserve(animeMotionAnimEl);
          }
        });
      },
      { threshold: 0, rootMargin: '0% 0% -10% 0%' }
    );

    observer.observe(animeMotionAnimEl);
  });
}

/*import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const gsapViewArr = document.querySelectorAll('[data-gsap-view]');
if (gsapViewArr.length > 0) {
  gsapViewArr.forEach((el, i) => {
    gsapViewAnimation(el, el, 25, 0, 0, 0);
  });

  function gsapViewAnimation(triggerEl, animEl, minY, minX, maxY, maxX) {
    if (ScrollTrigger.isTouch !== 1) {
      gsap.fromTo(
        animEl,
        {
          translateY: `${minY}%`,
          translateX: `${minX}%`,
          /!*opacity: 0,*!/
        },
        {
          translateY: `${maxY}%`,
          translateX: `${maxX}%`,
          /!*opacity: 1,*!/
          scrollTrigger: {
            trigger: triggerEl,
            end: 'top',
            scrub: true,
          },
        }
      );
    } else {
      /!*animEl.removeAttribute('data-scroll-bg');*!/
      /!*animEl.setAttribute('data-view', 'fade-t');*!/
    }
  }
}*/

if (document.getElementsByClassName('aura-card') && window.innerWidth > 551) {
  const page = document.querySelector('#site');
  const header = document.querySelector('header');
  const headerBurger = document.querySelector('.header .burger');
  const auraContainers = document.querySelectorAll('.aura-container');

  if (window.innerWidth > 1025) {
    auraContainers.forEach((container) => {
      const auraCursor = container.querySelector('.cursor-aura');
      const auraCursorWidth = auraCursor.offsetWidth;
      const auraCursorHeight = auraCursor.offsetHeight;

      const initLeft = parseFloat(getComputedStyle(auraCursor).left);
      const initTop = parseFloat(getComputedStyle(auraCursor).top);

      function cursorAuraLogic(e) {
        auraCursor.classList.add('active');
        const rect = container.getBoundingClientRect();
        let x = e.clientX - rect.left - auraCursorWidth / 1.85;
        let y = e.clientY - rect.top - auraCursorHeight / 1.95;

        const currentLeft = parseFloat(getComputedStyle(auraCursor).left);
        const currentTop = parseFloat(getComputedStyle(auraCursor).top);

        x -= currentLeft;
        y -= currentTop;

        requestAnimationFrame(() => {
          auraCursor.style.left = 0;
          auraCursor.style.top = 0;

          auraCursor.style.transform = `translate(${x}px, ${y}px)`;
        });
      }

      function cursorAuraLeaveLogic() {
        auraCursor.classList.remove('active');
        auraCursor.style.left = `${initLeft}px`;
        auraCursor.style.top = `${initTop}px`;
        auraCursor.style.transform = `translate(0, 0)`;
      }

      container.addEventListener('mousemove', (e) => {
        auraCursor.classList.add('is-init');
        cursorAuraLogic(e);
      });

      container.addEventListener('mouseleave', (event) => {
        const nextElement = document.elementFromPoint(
          event.clientX,
          event.clientY
        );

        if (header.contains(nextElement)) {
          return;
        }
        cursorAuraLeaveLogic();
      });

      if (header) {
        header.addEventListener('mousemove', (e) => {
          if (!header.classList.contains('open-menu')) {
            auraCursor.classList.add('is-init');
            cursorAuraLogic(e);
          }
        });

        header.addEventListener('mouseleave', (event) => {
          const nextElement = document.elementFromPoint(
            event.clientX,
            event.clientY
          );

          if (container.contains(nextElement)) {
            return;
          }
          cursorAuraLeaveLogic();
        });

        headerBurger.addEventListener('click', () => {
          cursorAuraLeaveLogic();
        });
      }

      window.addEventListener('DOMContentLoaded', (event) => {
        const isCursorOverElement = isCursorOverElementOnLoad(container);
        cursorAuraLogic(event);
      });
    });

    function isCursorOverElementOnLoad(element) {
      const rect = element.getBoundingClientRect();
      const mouseX = window.pageXOffset + rect.left;
      const mouseY = window.pageYOffset + rect.top;

      return (
        mouseX >= 0 &&
        mouseX <= window.innerWidth &&
        mouseY >= 0 &&
        mouseY <= window.innerHeight
      );
    }
  }
}

const scrollingText = document.querySelectorAll('.scrolling-text');
let scrollingTextSpeed = 25;
if (window.innerWidth > 1366) {
  scrollingTextSpeed = 20;
}
let scrollingTextTimeline = gsap.timeline();
if (scrollingText.length >= 1) {
  scrollingText.forEach((text, i) => {
    if (window.innerWidth >= 640) {
      const val = i % 2 === 0 ? scrollingTextSpeed : -scrollingTextSpeed;

      scrollingTextTimeline.to(text, {
        xPercent: val,
        scrollTrigger: {
          trigger: scrollingText[scrollingText.length - 2],
          start: 'center center',
          end: '+=1000',
          scrub: 0,
        },
      });
    }
  });
}

window.titlesSvgAnimation = function titlesSvgAnimation() {
  const titlesSvgAnimationsElArr = document.querySelectorAll(
    '.title-svg-hero-fade-animation'
  );

  if (titlesSvgAnimationsElArr.length) {
    titlesSvgAnimationsElArr.forEach((el) => {
      el.classList.add('is-title-svg-animate');
    });
  }
};
